module.exports = __webpack_public_path__ + "img/lens-150-minus-06.77da14a4.png";